var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        persistent: ""
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Disable All Plugins ")]
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _vm.loadingPlugins
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "64",
                              color: "primary"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        {
                          staticClass: "px-2",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _vm.installation
                            ? _c(
                                "p",
                                {
                                  staticClass: "mb-0"
                                },
                                [
                                  _vm.hasPlugins
                                    ? _c("span", [
                                        _vm._v(
                                          " This action will disable all WordPress plugins installed on " +
                                            _vm._s(
                                              _vm.installation.softdomain
                                            ) +
                                            ". "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " There are no active WordPress plugins detected for " +
                                            _vm._s(
                                              _vm.installation.softdomain
                                            ) +
                                            ". "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "px-5 pt-0 pb-3 justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPlugins,
                      expression: "hasPlugins"
                    }
                  ],
                  attrs: {
                    loading: _vm.submitting
                  },
                  on: {
                    click: _vm.deactivate
                  }
                },
                [_vm._v(" Disable ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }